/**
 * Tooltip module
 */
import TooltipDirective from './directives/TooltipDirective';
import 'tooltipster';

angular.module('edge.platform.widgets.tooltip', []).directive('gwTooltip', TooltipDirective);


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/tooltip/module.js
// module id = 789
// module chunks = 0